import React from "react";
import { Copy, Eye } from "iconsax-react";
import { Client } from "../../utilities/types/clients/types";

interface MobileClientCardProps {
  client: Client;
  onViewClick: () => void;
  onCopyClick: () => void;
  clientLink: string;
}

const MobileClientCard: React.FC<MobileClientCardProps> = ({ client, onViewClick, onCopyClick, clientLink }) => {
  return (
    <div className="flex flex-col items-center px-4 text-center *:w-full *:py-6 *:border-b *:border-b-gorgonzola-blue-100 text-closed-shutter-300" onClick={onViewClick}>
      <span className="font-bold line-clamp-1">{client.name}</span>

      <div className="grid grid-cols-1 gap-4">
        <div>
          <p className="text-xs text-closed-shutter-300/70">Reference ID</p>
          <p className="font-mono text-sm">{client.ref_id}</p>
        </div>

        <div>
          <p className="text-xs text-closed-shutter-300/70">Client Link</p>
          <p className="overflow-hidden text-xs text-gorgonzola-blue-400 text-ellipsis whitespace-nowrap">{clientLink}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCopyClick();
          }}
          className="flex items-center justify-center gap-2 px-3 py-2 text-xs font-medium transition-colors border rounded-lg text-gorgonzola-blue-400 border-gorgonzola-blue-200 hover:bg-gorgonzola-blue-50"
        >
          <Copy className="size-4" variant="Broken" />
          <span>Copy Link</span>
        </button>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onViewClick();
          }}
          className="flex items-center justify-center gap-2 px-3 py-2 text-xs font-medium transition-colors border rounded-lg text-closed-shutter-300 border-gorgonzola-blue-200 hover:bg-gorgonzola-blue-50"
        >
          <Eye className="size-4" variant="Broken" />
          <span>View Details</span>
        </button>
      </div>
    </div>
  );
};

export default MobileClientCard;
